/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classNames from 'classnames';

import baseStyles from '@nerdwallet/base-styles/styles.module.css';
import { Title } from '@nerdwallet/react-typography';

import Row from '../row/row';
import VerticalSpacer from '../vertical-spacer/vertical-spacer';
import parseMarkdownLinks from '../../lib/parse-md-links';

import './bulleted-list.less';

const BulletedList = ({
  anchorId,
  bullets,
  copyStyle,
  header,
  isModule,
  parseLinks,
  type,
}) => {
  const processCopyStyle = (style) => baseStyles[style] || style;
  const linkParser = (content) =>
    parseLinks ? parseMarkdownLinks(content, false) : content;

  const itemClasses = classNames([
    'bulleted-list__item',
    processCopyStyle(copyStyle),
  ]);

  const list = (
    <Fragment>
      {header && <Title size="small">{header}</Title>}
      <ul
        id={anchorId}
        className={classNames(
          `bulleted-list__type-${type}`,
          'bulleted-list__list'
        )}
      >
        {[].concat(bullets).map((bullet, index) => (
          <li className={itemClasses} key={index}>
            {linkParser(bullet)}
          </li>
        ))}
      </ul>
    </Fragment>
  );

  return isModule ? (
    <Row centeredInParent standardMaxWidths>
      {list}
      <VerticalSpacer mobile="p-18" tablet="p-18" desktop="p-18" />
    </Row>
  ) : (
    list
  );
};

BulletedList.displayName = 'BulletedList';

BulletedList.propTypes = {
  anchorId: PropTypes.string,
  bullets: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  ).isRequired,
  copyStyle: PropTypes.oneOf([
    'copy-h1',
    'copy-h2',
    'copy-h3',
    'copy-h4',
    'copy-h5',
    'copy-p1',
    'copy-p2',
    'text-default',
    'text-small',
  ]).isRequired,
  isModule: PropTypes.bool,
  header: PropTypes.string,
  parseLinks: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'check', 'none']),
};

BulletedList.defaultProps = {
  copyStyle: 'copy-p2',
  type: 'default',
  parseLinks: true,
};

export default BulletedList;
